<template>
    <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7'}" id="outermost">
      <van-nav-bar
        title="企业信息"
        left-text="返回"
        left-arrow
        @click-left="$router.back()"
        id="topbar"
      />
      <div style="padding:20px">
        <form action="/">
          <van-search
            v-model="companyName"
            placeholder="请输入企业名称"
            @search="onSearch"
            shape="round"
            background="#F7F7F7"
          />
              <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              :immediate-check="false"
              >
                <div v-for="(item,index) in companyList" :key="index" class='companyItem' @click="toCompanyInfo(item.id)">
                  <div class='sellout'>
                    {{item.typeName}}
                  </div>
                  <div class="companyName">
                    {{item.companyName}}
                  </div>
                  <div class="companyLink">
                    联系人：<span>{{item.contacts1}}</span>
                  </div>
                  <div class="companyLink">
                    联系电话：<span>{{item.phone1}}</span>
                  </div>
                  <div class="companyLink">
                    <van-row type="flex" justify="space-between" align="center">
                      <van-col span="20">
                        参与项目：<span>{{item.projectNames}}</span>
                      </van-col>
                      <van-col span="4" v-if="item.workCount===0" style="color:#1B75F6;text-align:right;">
                        未核查
                      </van-col>
                      <van-col span="4" v-else-if="item.workCount>0" style="color:#1B75F6;text-align:right;">
                        已核查
                      </van-col>
                    </van-row>

                  </div>
                </div>
              </van-list>
        </form>
      </div>
    </div>
</template>
<script>
    import $ from '@/fly'
    export default {
        name: 'project-allCompanyList',
        data () {
            return {
                clientHeight: window.screen.height,
                companyName: '',
                proName: '',
                loading: false,
                finished: false,
                companyList: []
            }
        },
        computed: {
        },
        methods: {
            onSearch () {
                this.loadList();
            },
            loadList () {
                var that = this;
                $.get('company/findCompanyByProjectId', {
                    companyName: this.companyName,
                    projectIds: localStorage.getItem('projectIds')
                }).then(res => {
                    that.companyList = res;
                    // 加载状态结束
                    that.loading = false;
                    that.finished = true;
                })
            },
            toCompanyInfo (id) {
                localStorage.setItem('companyId', id);
                this.$router.push({ name: 'project-companyInfo' });
            }
        },
        mounted () {
            this.proName = localStorage.getItem('projectName');
            this.loadList();
        }
    }

</script>

<style lang="less" scoped>
  .van-search{
    padding: 0px;
  }
  .van-list{
    margin-top:20px;
  }
  .companyItem {
    width: 100%;
    min-height: 230px;
    background-color: white;
    margin: 10rpx 0;
    overflow: hidden;
    position: relative;
    margin-bottom: 20px;
    padding: 0px 30px;
    border:1px solid #1B75F6;
  }

  .sellout {
    background-color: #1B75F6;
    color: white;
    font-size: 18px;
    font-weight: 300;
    width: 70%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    margin-left: 54%;
    margin-top: 30px;
    position: absolute;
    transform: rotate(45deg);
  }
  .companyName{
    color: #1F56F4;
    font-size: 30px;
    font-weight: 800;
    line-height: 70px;
    margin-top: 10px;
  }
  .companyLink{
    color: #464646;
    font-size: 20px;
    font-weight: 500;
    line-height: 45px;
  }
</style>
